/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiBaseAlertStatusConf } from './InternalApiBaseAlertStatusConf';
import {
    InternalApiBaseAlertStatusConfFromJSON,
    InternalApiBaseAlertStatusConfFromJSONTyped,
    InternalApiBaseAlertStatusConfToJSON,
    InternalApiBaseAlertStatusConfToJSONTyped,
} from './InternalApiBaseAlertStatusConf';

/**
 * a custom screening alert status
 * @export
 * @interface InternalApiScreeningAlertStatus
 */
export interface InternalApiScreeningAlertStatus {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningAlertStatus
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningAlertStatus
     */
    textName: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningAlertStatus
     */
    startTime: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    enabledScreening: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    enabledMonitoring: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    enabledBridge?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    enabledManual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    isFinal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    isGoodlistable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    isImportant: boolean;
    /**
     * 
     * @type {InternalApiBaseAlertStatusConf}
     * @memberof InternalApiScreeningAlertStatus
     */
    _configuration: InternalApiBaseAlertStatusConf;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningAlertStatus
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningAlertStatus
     */
    endTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningAlertStatus
     */
    isSystem?: boolean;
}

/**
 * Check if a given object implements the InternalApiScreeningAlertStatus interface.
 */
export function instanceOfInternalApiScreeningAlertStatus(value: object): value is InternalApiScreeningAlertStatus {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('textName' in value) || value['textName'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('enabledScreening' in value) || value['enabledScreening'] === undefined) return false;
    if (!('enabledMonitoring' in value) || value['enabledMonitoring'] === undefined) return false;
    if (!('isFinal' in value) || value['isFinal'] === undefined) return false;
    if (!('isGoodlistable' in value) || value['isGoodlistable'] === undefined) return false;
    if (!('isImportant' in value) || value['isImportant'] === undefined) return false;
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    return true;
}

export function InternalApiScreeningAlertStatusFromJSON(json: any): InternalApiScreeningAlertStatus {
    return InternalApiScreeningAlertStatusFromJSONTyped(json, false);
}

export function InternalApiScreeningAlertStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningAlertStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'textName': json['textName'],
        'startTime': (new Date(json['startTime'])),
        'enabledScreening': json['enabledScreening'],
        'enabledMonitoring': json['enabledMonitoring'],
        'enabledBridge': json['enabledBridge'] == null ? undefined : json['enabledBridge'],
        'enabledManual': json['enabledManual'] == null ? undefined : json['enabledManual'],
        'isFinal': json['isFinal'],
        'isGoodlistable': json['isGoodlistable'],
        'isImportant': json['isImportant'],
        '_configuration': InternalApiBaseAlertStatusConfFromJSON(json['configuration']),
        'id': json['id'] == null ? undefined : json['id'],
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'isSystem': json['isSystem'] == null ? undefined : json['isSystem'],
    };
}

export function InternalApiScreeningAlertStatusToJSON(json: any): InternalApiScreeningAlertStatus {
    return InternalApiScreeningAlertStatusToJSONTyped(json, false);
}

export function InternalApiScreeningAlertStatusToJSONTyped(value?: InternalApiScreeningAlertStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'textName': value['textName'],
        'startTime': value['startTime'].toISOString(),
        'enabledScreening': value['enabledScreening'],
        'enabledMonitoring': value['enabledMonitoring'],
        'enabledBridge': value['enabledBridge'],
        'enabledManual': value['enabledManual'],
        'isFinal': value['isFinal'],
        'isGoodlistable': value['isGoodlistable'],
        'isImportant': value['isImportant'],
        'configuration': InternalApiBaseAlertStatusConfToJSON(value['_configuration']),
        'id': value['id'],
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'isSystem': value['isSystem'],
    };
}

